<template>
  <base-content>
    <template v-slot:top>
      <hero-header :heading="`Register as ${payloads.user.role === 'borrower' ? 'a' : 'an'} ${payloads.user.role}`">
        <p>
          It's great to have you with us. The following steps will take you through the registration process.
        </p>
      </hero-header>
    </template>
    <form @submit.prevent="submit">
      <base-field label="First Name">
        <base-input v-model="payloads.profile.firstName" personal placeholder="first name" required />
      </base-field>
      <base-field label="Last Name">
        <base-input v-model="payloads.profile.lastName" personal placeholder="last name" required />
      </base-field>
      <base-field label="E-Mail Address">
        <base-input v-model="payloads.user.email" personal placeholder="email" required type="email" />
      </base-field>
      <base-field label="Password">
        <base-input v-model="payloads.user.password" personal placeholder="password" required type="password" />
      </base-field>
      <base-checkbox v-model="terms" required>
        Please confirm that you have read and accepted the terms of conditions.
      </base-checkbox>
      <base-checkbox v-model="payloads.profile.preferences.optInMarketing">
        As this is an online platform, we look to communicate with you via email where possible
        and sometimes via other communication types. Please confirm that you have read and
        understood our privacy policy and consent to us communicating with you. You can opt-out
        of communication at any time.
      </base-checkbox>
      <div class="row mt-4">
        <div class="col-sm-6">
          <base-button exact :to="{ name: 'register' }">Back</base-button>
        </div>
        <div class="col-sm-6 text-right">
          <base-button icon-right="arrow-right" :loading="saving" primary submit>
            Register
          </base-button>
        </div>
      </div>
    </form>
  </base-content>
</template>

<script>
// TODO Check if this page can be safely removed
import { mapGetters, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    HeroHeader
  },

  data: () => ({
    saving: false,
    payloads: {
      profile: {},
      user: {}
    },
    terms: false
  }),

  created () {
    this.payloads.profile = this.profileSchema
    this.payloads.user = this.schema
    this.setRole()
  },

  beforeDestroy () {
    this.$store.commit('core/auth/error', {})
  },

  computed: {
    ...mapGetters({
      accountSchema: 'core/user-account/schema',
      profileSchema: 'core/user-profile/schema',
      schema: 'core/users/schema'
    }),

    ...mapState({
      account: store => store.core.userAccount.entity,
      authError: store => store.core.auth.error,
      authErrors: store => store.core.auth.errors,
      profile: store => store.core.userProfile.entity,
      registered: store => store.core.auth.registered
    })
  },

  methods: {
    setRole () {
      const role = this.$_.get(this.$route.meta, 'role') || 'borrower'

      this.payloads.user.role = role
    },

    async submit () {
      this.saving = true

      // Attempt to register the user, we must do this first so they're issued the token
      // required to create their profile.
      await this.$store.dispatch('core/auth/register', this.payloads.user)

      if (!this.authError) {
        // Set the token so we can create their profile before authenticating them onto the platform.
        this.$store.commit('core/auth/authorize', this.registered)

        // Create the user profile.
        await this.$store.dispatch('core/user-profile/save', this.payloads.profile)
        await this.$store.dispatch('core/user-account/save', this.accountSchema)
        await this.$store.dispatch('core/users/save', {
          _id: this.registered._id,
          account: this.account._id,
          profile: this.profile._id
        })

        // Authenticate the user once they have been successfully registered.
        await this.$store.dispatch('core/auth/authorize', this.registered)

        this.$router.push({ name: 'register.details' })
      } else {
        this.$flash.failure(this.authError)
      }

      this.saving = false
    }
  },

  watch: {
    $route: {
      deep: true,
      handler () {
        this.setRole()
      }
    }
  }
}
</script>
